import axios from 'axios';

export default {
    methods: {
        async configListado(ok, err) {
            try {
                let r = await axios.post('config/listado');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async configSet(d, ok, err) {
            try {
                let r = await axios.post('config/set', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async configSetByName(d, ok, err) {
            try {
                let r = await axios.post('config/set-by-name', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async configGet(d, ok, err) {
            try {
                let r = await axios.post('config/get', {nom: d, all: false});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async configGetAll(d, ok, err) {
            try {
                let r = await axios.post('config/get', {nom: d, all: true});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/config.js